import flagCz from '@/assets/flags/flag-cz.svg';
import flagDe from '@/assets/flags/flag-de.svg';
import flagEs from '@/assets/flags/flag-es.svg';
import flagFr from '@/assets/flags/flag-fr.svg';
import flagGb from '@/assets/flags/flag-gb.svg';
import flagGr from '@/assets/flags/flag-gr.svg';
import flagHu from '@/assets/flags/flag-hu.svg';
import flagIt from '@/assets/flags/flag-it.svg';
import flagNl from '@/assets/flags/flag-nl.svg';
import flagNo from '@/assets/flags/flag-no.svg';
import flagPl from '@/assets/flags/flag-pl.svg';
import flagPt from '@/assets/flags/flag-pt.svg';
import flagSk from '@/assets/flags/flag-sk.svg';
import flagUs from '@/assets/flags/flag-us.svg';

export interface AvailableLocale {
  code: string;
  name: string;
  flag: string;
}

export const AVAILABLE_LOCALES: AvailableLocale[] = [
  { code: 'cs-CZ', name: 'Čeština (Česko)', flag: flagCz },
  { code: 'de-DE', name: 'Deutsch (Deutschland)', flag: flagDe },
  { code: 'el-GR', name: 'Ελληνικά (Ελλάδα)', flag: flagGr },
  { code: 'en-GB', name: 'British English', flag: flagGb },
  { code: 'en-US', name: 'American English', flag: flagUs },
  { code: 'es-ES', name: 'Español De España', flag: flagEs },
  { code: 'fr-FR', name: 'Français (France)', flag: flagFr },
  { code: 'hu-HU', name: 'Magyar (Magyarország)', flag: flagHu },
  { code: 'it-IT', name: 'Italiano (Italia)', flag: flagIt },
  { code: 'nb-NO', name: 'Norsk bokmål (Norge)', flag: flagNo },
  { code: 'nl-NL', name: 'Nederlands (Nederland)', flag: flagNl },
  { code: 'pl-PL', name: 'Polski (Polska)', flag: flagPl },
  { code: 'pt-PT', name: 'Português Europeu', flag: flagPt },
  { code: 'sk-SK', name: 'Slovenčina (Slovensko)', flag: flagSk },
];

export const DEFAULT_LOCALE_CODE = 'en-GB';

export function findAvailableLocaleCode(locale: string): string | undefined {
  const normalized = locale.toLowerCase();
  const [language] = normalized.split('-');

  return (
    AVAILABLE_LOCALES.find(({ code }) => code.toLowerCase() === normalized)?.code ??
    AVAILABLE_LOCALES.find(({ code }) => code.toLowerCase().startsWith(`${language}-`))?.code
  );
}
